export default __webpack_public_path__ + "static/media/S-017.e931e5d2.png";